/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
 
export default {
    name: "labTest",
    components: {
    VPagination,
  },
    data() {
        return {
            showLoading: true,
            labList: [],
            baseurl: process.env.VUE_APP_Service_URL,
            testName: "",
            category: "",
            activeSortColumn: "",
            testCode: "",
            token: "",           
            pageNumber: 1,
            currentPageNumber: 1,
            SortOrder:0,
            SortProperty:"",
            currentPage:1,
            totalItems: 0,
             totalPage: 0,
        };
    },
    async mounted() {
        this.token = store.getters.getIdToken;
        await this.getLabTest();
    },
    methods: {
        async getLabTest() {
            this.showLoading = true;
            try {
            const response = await axios.get(
                `${this.baseurl}/management/labtest/labtestlist?StudyId=${store.getters.getStudyIs}&pageindex=${this.currentPage}&pagesize=10&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
                
                {
                headers: {
                    Authorization: "Bearer " + this.token,
                    "Content-Type": "application/json",
                },
                }
            );
            console.log("labs are", response.data);
            this.labList = response.data && response.data.results? response.data.results : [];
            
            this.totalItems = Math.ceil(response.data.totalCount / 10);
            
            } catch (err) {
            console.log("error..", err);
            } finally {
            this.showLoading = false;
            }
        },
        async editlabtest(id) {
           this.$router.push(`/editLabtest/${id}`);
        },
        async createLabTest(id) {
            this.$router.push(`/editLabtest/${id}`);
        },
        async deleteLabs(testId) {
            if (confirm(this.$t('navigations.are you sure you want to delete this lab?'))) {
            await axios
                .delete(
                `${this.baseurl}/management/labtest/deletebyid?LabTestID=${testId}`,
                {
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "Content-Type": "application/json",
                    },
                }
                )
                .then((response) => {
                if (response.data) {
                    this.labList = response.data.results;
                }
                })
                .catch((err) => {
                console.log(err);
                alert(err.response?.data?.detail || "Delete failed");
                });
            alert(this.$t("navigations.lab test deleted successfully"));
            await this.getLabTest();
           
            }
        },
        async SearchButtonClicked() {
        this.pageNumber=1;
        this.currentPageNumber=1;
        this.searchData()
        },
       SortSelected(property) {
      
            if (this.SortProperty === property) {
                this.SortOrder = this.SortOrder === 0 ? 1 : 0;
            } else {
            
                this.SortProperty = property;
                this.SortOrder = 0;
            }
            this.activeSortColumn = property;
            console.log(`Sorting by ${property}, order: ${this.SortOrder}`);
            this.getLabTest();
      },
 
        async searchData() {
            this.showLoading = true;
            try {
            const response = await axios.get(
                `${this.baseurl}/management/labtest/labtestlist?TestCode=${this.testCode}&TestName=${encodeURIComponent(this.testName)}&Category=${this.category}&StudyId=${store.getters.getStudyIs}&Status&pageindex=${this.pageNumber}&pagesize=10`,
                {
                headers: {
                    Authorization: "Bearer " + this.token,
                    "Content-Type": "application/json",
                },
                }
            );
            console.log(response);
            if (response.data) {
                this.totalItems = Math.ceil(response.data.totalCount / 10);
                this.labList = response.data.results;
            } else {
                console.log("no labs found");
            }
            } catch (error) {
            console.log(error);
            this.enableNext = false;
            this.enablePrevious = false;
            } finally {
            this.showLoading = false;
            }
        },
          loadPage: function (page) {
      this.currentPage = page;
      this.pageindex = page;
      this.getLabTest();
    },
       
       
    },
};